<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nJ1CSm/tc-custom/9781429965699.jpg?1722312427884" alt="This image is the cover for the book Breakthrough"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Breakthrough
      </h1>
      <p class="bookDescription body article font2">
        <p>It is 1919 and Elizabeth Hughes, the eleven-year-old daughter of America's most-distinguished jurist and politician, Charles Evans Hughes, has been diagnosed with juvenile diabetes. It is essentially a death sentence. The only accepted form of treatment – starvation – whittles her down to forty-five pounds skin and bones. Miles away, Canadian researchers Frederick Banting and Charles Best manage to identify and purify insulin from animal pancreases – a miracle soon marred by scientific jealousy, intense business competition and fistfights. In a race against time and a ravaging disease, Elizabeth becomes one of the first diabetics to receive insulin injections – all while its discoverers and a little known pharmaceutical company struggle to make it available to the rest of the world. <br/><br/>Relive the heartwarming true story of the discovery of insulin as it's never been told before. Written with authentic detail and suspense, and featuring walk-ons by William Howard Taft, Woodrow Wilson, and Eli Lilly himself, among many others.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thea Cooper, Arthur Ainsberg
      </h2>
      
      <p class="authorDescription body article"><P>THEA COOPER is an author, playwright, editor and teacher. ARTHUR AINSBERG is an author and financial industry veteran whose successful battle with Hodgkin's disease sparked his interest in medical history.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14fdfe81